export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'How do I mark something as watched?',
    answer:
      'Open any movie or show and use the watched control on its page. For shows you can mark individual episodes, a whole season, or use "Mark all episodes watched" once a season has aired. Your progress bars update as you go.',
  },
  {
    question: 'How do ratings work?',
    answer:
      'You can rate anything you have watched on a 1-10 scale in half-star steps. Rating is unlocked once a title is marked watched (or released), so you always rate things you have actually seen.',
  },
  {
    question: 'Why can\'t I add an unreleased title to my history?',
    answer:
      'Titles that have not been released yet can be added to your watchlist but not marked watched - you can\'t have watched something that isn\'t out. Once the release date passes, the watched and rating controls unlock automatically.',
  },
  {
    question: 'How does spoiler protection work?',
    answer:
      'With spoiler control on, episode stills and overviews for episodes you have not watched stay blurred so a glance at a season page never spoils what is coming. You can reveal a single show at a time without affecting the others.',
  },
  {
    question: 'How do I change the page I land on?',
    answer:
      'In Settings under Preferences you can pick your default landing page. Fresh visits to the site will send you straight there instead of the home page.',
  },
  {
    question: 'How do I delete my account?',
    answer:
      'Account deletion lives in Settings. Removing your account clears your library, history, and settings. If you run into trouble, email us and we will help.',
  },
  {
    question: 'Is Movieception free?',
    answer:
      'Yes. Create an account to track your watching, build a watchlist, rate and comment, and sync across the website and the iOS app.',
  },
  {
    question: 'Some movie or show data looks wrong. Can you fix it?',
    answer:
      'Movie and TV data comes from The Movie Database (TMDB). We don\'t edit that data directly - corrections are made on TMDB and flow back to us. If something still looks off after that, let us know and we will take a look.',
  },
]
